<template>
  <BaseCustomizeMetal componentCode="AE">
    <template slot="respect" slot-scope="{ text }">
      <div class="text">
        <span v-html="text.split('')[0] || ''"></span>
        <span v-html="text.split('')[1] || ''"></span>
      </div>
    </template>
  </BaseCustomizeMetal>
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalAE",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 77px;
    left: 147px;
    @include betweenTableTablePro {
      top: 52px;
      left: 96px;
    }
    @include table {
      top: 30px;
      left: 72px;
    }
    @include phone {
      top: 28px;
      left: 54px;
    }
  }
  .templeName {
    height: 33px;
    width: 204px;
    .textContainer {
      width: 204px;
    }
  }
  .godName {
    width: 208px;
    height: 58px;
    .textContainer {
      width: 208px;
    }
  }
  .gift {
    width: 171px;
    height: 33px;
    .textContainer {
      width: 171px;
    }
  }
  .respect {
    margin: 6px auto;
    .text {
      position: relative;
      span {
        position: absolute;
      }
      span:nth-child(1) {
        left: -25px;
      }
      span:nth-child(2) {
        right: -17px;
      }
    }
  }
}
</style>
